<template>
<div
	:class="{'triangle-mark clickable': activityLabel}"
	class="row row-col-1 g-0 m-1 text-center half-transparent-border tile"
>
    <div
		v-if="title.length > 0"
		class="col"
		style="max-height: 15%;"
	>
        <span class="tile-title px-2 pt-1 text-center text-wrap">
			{{ title }}
		</span>
    </div>
	<div
		class="row my-1 mx-0"
		:class="{
			'px-1': isMobile,
			'px-2': isDesktop,
		}"
		style="height: 80%;"
	>
		<!-- Tile payload -->
		<slot></slot>
	</div>
</div>
</template>




<script>
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'

export default {
    props: {
		title: {
			type: String,
			required: false,
            default: '',
		},
		// Triangle mark on the right side of the vidget and make vidget clickable
        activityLabel: {
            type: Boolean,
            required: false,
            default: false,
        }
	},

	setup() {
		const { isMobile, isDesktop } = useSizeBreakpoint()

		return {
			isMobile,
			isDesktop,
		}
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style>
.tile {
	width: calc(100% - 8px);

	min-height: 8.65rem;
	/* max-height: 9.40rem; */
	height: calc(100% - 8px);
	/* Hide scroll bar, but while still being able to scroll */
	scrollbar-width: none;
}

.tile-title {
	text-overflow: ellipsis;
	font-weight: bold;
	overflow: hidden;
	white-space: nowrap;
	max-width: calc(100% - 2px);
	cursor: pointer;
	font-size: 0.83rem;
	margin-top: 0.2rem;
}

/* .tile-payload {

} */
</style>